import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import DashboardNavbar from "./DashboardNavbar";
import DashboardSidebar from "./DashboardSidebar";
import CountryList from "./CountryList";

// Import Google Play Store components
import OverviewGoogle from "./google-play-store-dashboard/Overview";
import KeywordResearchGoogle from "./google-play-store-dashboard/keyword-research/KeywordResearch";
import KeywordRelevanceGoogle from "./google-play-store-dashboard/keyword-research/KeywordRelevancy";
import SuggestedKeywordsGoogle from "./google-play-store-dashboard/keyword-research/SuggestedKeywords";
import KeywordDifficultyGoogle from "./google-play-store-dashboard/keyword-research/KeywordDifficulty";
import KeywordHealthGoogle from "./google-play-store-dashboard/keyword-research/KeywordHealth";
import CompetitorAnalysisGoogle from "./google-play-store-dashboard/CompetitorAnalysis";
import CompetitorScreenshotsGoogle from "./google-play-store-dashboard/CompetitorScreenshots";
import AdMob from "./google-play-store-dashboard/AdMob";

import ReviewAndRatingManagementGoogle from "./google-play-store-dashboard/ReviewAndRatingManagement";
import LocalizationGoogle from "./google-play-store-dashboard/Localization";
import ASOAuditGoogle from "./google-play-store-dashboard/ASOAudit";
import AnalyticsAndReportingGoogle from "./google-play-store-dashboard/analytics-reporting/AnalyticsAndReporting";
import KPIDataGoogle from "./google-play-store-dashboard/analytics-reporting/KPIData";
import ForecastAppGoogle from "./google-play-store-dashboard/ForecastApp";
import LocalizedASOInsightsGoogle from "./google-play-store-dashboard/LocalizedASOInsights";
import MarketInsightsGoogle from "./google-play-store-dashboard/MarketInsights";


// Import Apple App Store components
import OverviewApple from "./apple-app-store-dashboard/Overview";
import KeywordResearchApple from "./apple-app-store-dashboard/keyword-research/KeywordResearch";
import KeywordRelevanceApple from "./apple-app-store-dashboard/keyword-research/KeywordRelevancy";
import SuggestedKeywordsApple from "./apple-app-store-dashboard/keyword-research/SuggestedKeywords";
import KeywordDifficultyApple from "./apple-app-store-dashboard/keyword-research/KeywordDifficulty";
import KeywordHealthApple from "./apple-app-store-dashboard/keyword-research/KeywordHealth";
import CompetitorAnalysisApple from "./apple-app-store-dashboard/CompetitorAnalysis";
import CompetitorScreenshotsApple from "./apple-app-store-dashboard/CompetitorScreenshots";
import AdMobApple from "./apple-app-store-dashboard/AdMob";
import ReviewAndRatingManagementApple from "./apple-app-store-dashboard/ReviewAndRatingManagement";
import LocalizationApple from "./apple-app-store-dashboard/Localization";
import ASOAuditApple from "./apple-app-store-dashboard/ASOAudit";
import AnalyticsAndReportingApple from "./apple-app-store-dashboard/analytics-reporting/AnalyticsAndReporting";
import KPIDataApple from "./apple-app-store-dashboard/analytics-reporting/KPIData";
import ForecastAppApple from "./apple-app-store-dashboard/ForecastApp";
import LocalizedASOInsightsApple from "./apple-app-store-dashboard/LocalizedASOInsights";
import MarketInsightsApple from "./apple-app-store-dashboard/MarketInsights";


import "./DashboardStyles.css"; // Importing the CSS file for styling

const DashboardLayout = () => {
  const [selectedStore, setSelectedStore] = useState("play-store");
  const [isSidebarOpen, setIsSidebarOpen] = useState(true); // Default open on desktop

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleStoreChange = (store) => {
    setSelectedStore(store);
  };

  const renderRoutesForStore = (store) => {
     // Helper to reduce code duplication
     const Components = store === "play-store" ? {
         Overview: OverviewGoogle,
         KeywordResearch: KeywordResearchGoogle,
         KeywordRelevance: KeywordRelevanceGoogle,
         SuggestedKeywords: SuggestedKeywordsGoogle,
         KeywordDifficulty: KeywordDifficultyGoogle,
         KeywordHealth: KeywordHealthGoogle,
         CompetitorAnalysis: CompetitorAnalysisGoogle,
         CompetitorScreenshots: CompetitorScreenshotsGoogle,
         AdMob: AdMob,
         ReviewRating: ReviewAndRatingManagementGoogle,
         Localization: LocalizationGoogle,
         Forecast: ForecastAppGoogle,
         ASOAudit: ASOAuditGoogle,
         Analytics: AnalyticsAndReportingGoogle,
         KPI: KPIDataGoogle,
         Localized: LocalizedASOInsightsGoogle,
         Market: MarketInsightsGoogle
     } : {
         Overview: OverviewApple,
         KeywordResearch: KeywordResearchApple,
         KeywordRelevance: KeywordRelevanceApple,
         SuggestedKeywords: SuggestedKeywordsApple,
         KeywordDifficulty: KeywordDifficultyApple,
         KeywordHealth: KeywordHealthApple,
         CompetitorAnalysis: CompetitorAnalysisApple,
         CompetitorScreenshots: CompetitorScreenshotsApple,
         AdMob: AdMobApple,
         ReviewRating: ReviewAndRatingManagementApple,
         Localization: LocalizationApple,
         Forecast: ForecastAppApple,
         ASOAudit: ASOAuditApple,
         Analytics: AnalyticsAndReportingApple,
         KPI: KPIDataApple,
         Localized: LocalizedASOInsightsApple,
         Market: MarketInsightsApple
     };

     return (
         <>
            <Route path="overview" element={<Components.Overview />} />
            <Route path="keyword-research" element={<Components.KeywordResearch />} />
            <Route path="keyword-relevancy" element={<Components.KeywordRelevance />} />
            <Route path="suggested-keywords" element={<Components.SuggestedKeywords />} />
            <Route path="keyword-difficulty" element={<Components.KeywordDifficulty />} />
            <Route path="keyword-health" element={<Components.KeywordHealth />} />
            <Route path="competitor-analysis" element={<Components.CompetitorAnalysis />} />
            <Route path="competitor-screenshots" element={<Components.CompetitorScreenshots />} />
            <Route path="ad-mob" element={<Components.AdMob />} />
            <Route path="review-rating-management" element={<Components.ReviewRating />} />
            <Route path="localization" element={<Components.Localization />} />
            <Route path="forecast-app" element={<Components.Forecast />} />
            <Route path="aso-audit" element={<Components.ASOAudit />} />
            <Route path="analytics-reporting" element={<Components.Analytics />} />
            <Route path="kpi-data" element={<Components.KPI />} />
            <Route path="localized-aso-insights" element={<Components.Localized />} />
            <Route path="market-insights" element={<Components.Market />} />
         </>
     );
  };

  return (
    <div className="flex h-screen overflow-hidden bg-gray-50">
      {/* Sidebar */}
      <div className={`fixed inset-y-0 left-0 z-50 w-80 transform transition-transform duration-300 ease-in-out ${
          isSidebarOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <DashboardSidebar isOpen={isSidebarOpen} onClose={toggleSidebar} />
      </div>

      {/* Main Content */}
      <div className={`flex-1 flex flex-col transition-all duration-300 ease-in-out ${isSidebarOpen ? "ml-80" : "ml-0"}`}>
        <DashboardNavbar 
            onStoreChange={handleStoreChange} 
            toggleSidebar={toggleSidebar} 
            isSidebarOpen={isSidebarOpen}
        />
        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-50 p-6">
          <Routes>
            <Route path="countries" element={<CountryList />} />
            {renderRoutesForStore(selectedStore)}
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
